import React from "react";
import { Card, Row, Col, Badge } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faFileAlt, 
  faCalendarAlt, 
  faStore,
  faMicrochip,
  faExclamationTriangle
} from "@fortawesome/free-solid-svg-icons";

const ReportHeader = ({ selectedReport }) => {
  return (
    <Card className="shadow-sm report-card mb-3">
      <Card.Header className="bg-secondary text-white">
        <Row className="align-items-center">
          <Col>
            <h5 className="mb-0">
              <FontAwesomeIcon icon={faFileAlt} className="me-2" />
              Raport Systemu ROSS
            </h5>
          </Col>
          <Col xs="auto">
            <Badge bg="light" text="dark">
              Wersja {selectedReport.version || '1.0'}
            </Badge>
          </Col>
        </Row>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col md={4}>
            <p className="mb-1">
              <FontAwesomeIcon icon={faCalendarAlt} className="text-muted me-2" />
              <strong>Data raportu:</strong><br />
              <small>{new Date(selectedReport.addedAt).toLocaleString("pl-PL")}</small>
            </p>
          </Col>
          <Col md={4}>
            <p className="mb-1">
              <FontAwesomeIcon icon={faStore} className="text-muted me-2" />
              <strong>Drogerie w systemie:</strong><br />
              <small>{selectedReport.data?.totalShops || 0} lokalizacji</small>
            </p>
          </Col>
          <Col md={4}>
            <p className="mb-1">
              <FontAwesomeIcon icon={faMicrochip} className="text-muted me-2" />
              <strong>Urządzenia:</strong><br />
              <small>{selectedReport.data?.totalAuthDevices || 0} autoryzowanych</small>
            </p>
          </Col>
        </Row>
        {selectedReport.data?.notRespondingDeviceTimeoutInHours && (
          <Row className="mt-2">
            <Col>
              <small className="text-muted">
                <FontAwesomeIcon icon={faExclamationTriangle} className="me-1" />
                Timeout nieodpowiadających urządzeń: {selectedReport.data.notRespondingDeviceTimeoutInHours}h
              </small>
            </Col>
          </Row>
        )}
      </Card.Body>
    </Card>
  );
};

export default ReportHeader;